import { axiosSwagger } from "@/axios";

export const state = {
    // posted files
    postedFiles: {
        loading: false,
        data: [],
    }
}


export const getters = {
}


export const mutations = {
    // POSTED FILES
    postedFilesLoading: (state, loading) => {
        state.postedFiles.loading = loading;
    },
    setPostedFilesData: (state, data) => {
        state.postedFiles.data = data;
    },
}


export const actions = {
    // READ POSTED FILES
    async readPostedFiles({ commit }) {
        commit("postedFilesLoading", true);
    
        return await axiosSwagger
          .get("/api/FilePosting/Me/Available")
          .then((response) => {
            commit("setPostedFilesData", response.data);
            commit("postedFilesLoading", false);
    
            return response;
          })
          .catch(() => {
            commit("postedFilesLoading", false);
          });
      }
}
